/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  'use strict';
  
  const CLEANUP_COOKIE_NAME = 'goodie_action_cleanup_done';
  const CLEANUP_COOKIE_DAYS = 30;
  
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
  
  async function cleanupGoodiesAfterAction() {
    // 1. Check ob Cookie vorhanden ist
    if (getCookie(CLEANUP_COOKIE_NAME)) {
      return;
    }
    
    try {
      // 2. Warenkorb abrufen
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart || !cart.items || cart.items.length === 0) {
        setCookie(CLEANUP_COOKIE_NAME, 'true', CLEANUP_COOKIE_DAYS);
        return;
      }
      
      // 3. Goodie Variant IDs aus DOM holen (nutzt deine Konfiguration)
      const goodieEls = document.querySelectorAll('.goodie-values');
      if (!goodieEls.length) {
        setCookie(CLEANUP_COOKIE_NAME, 'true', CLEANUP_COOKIE_DAYS);
        return;
      }
      
      const goodieVariantIds = Array.from(goodieEls).map(el => 
        parseInt(el.dataset.variantId, 10)
      );
      
      // 4. Prüfen ob Goodies im Warenkorb sind
      const goodiesInCart = cart.items.filter(item => 
        goodieVariantIds.includes(item.variant_id)
      );
      
      if (goodiesInCart.length === 0) {
        setCookie(CLEANUP_COOKIE_NAME, 'true', CLEANUP_COOKIE_DAYS);
        return;
      }
      
      // 5. Goodies entfernen
      console.log(`🧹 Entferne ${goodiesInCart.length} Goodie(s) aus dem Warenkorb...`);
      
      for (const goodieItem of goodiesInCart) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: goodieItem.key,
            quantity: 0
          })
        });
      }
      
      // 6. Cart neu rendern OHNE zu öffnen
      setTimeout(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      }, 300);
      
      console.log('✅ Goodies erfolgreich entfernt (Aktions-Cleanup)');
      
    } catch (error) {
      console.error('❌ Fehler beim Goodie-Cleanup:', error);
    }
    
    // 7. Cookie setzen (auch bei Fehler)
    setCookie(CLEANUP_COOKIE_NAME, 'true', CLEANUP_COOKIE_DAYS);
  }
  
  // Beim Seitenladen ausführen
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupGoodiesAfterAction);
  } else {
    cleanupGoodiesAfterAction();
  }
  
})();

/* ----------------------------------------------------------
   2) GOODIE KONFIGURATION AUS DEM DOM HOLEN
      (ALLE .goodie-values ALS ARRAY)
----------------------------------------------------------- */
function getGoodieConfigs() {
  const goodieEls = document.querySelectorAll('.goodie-values');
  if (!goodieEls.length) return [];

  return Array.from(goodieEls).map((el) => ({
    productTitle: el.dataset.productTitle,
    variantId: parseInt(el.dataset.variantId, 10),
    threshold: parseInt(el.dataset.goodieThreshold, 10) // z.B. 8000 (80 € in Cent)
  }));
}


/* ----------------------------------------------------------
   3) CART ABRUFEN
----------------------------------------------------------- */
async function fetchCart() {
  const response = await fetch('/cart.js');
  return await response.json();
}


/* ----------------------------------------------------------
   4) GOODIE HINZUFÜGEN
----------------------------------------------------------- */
async function addGoodieToCart(variantId) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  });

  return await response.json();
}


/* ----------------------------------------------------------
   5) GOODIE ENTFERNEN
----------------------------------------------------------- */
async function removeGoodieFromCart(lineItemKey) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: 0
    })
  });

  setTimeout(() => {
          document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        )}, 500);
}

/* ----------------------------------------------------------
   6) GOODIE-LOGIK:
      - Threshold auf Warenkorb OHNE jeweiliges Goodie prüfen
      - Goodies hinzufügen / entfernen
----------------------------------------------------------- */
async function checkAndSyncGoodie() {
  const goodies = getGoodieConfigs();
  if (!goodies.length) return;

  const cart = await fetchCart();
  if (!cart || !cart.items) return;

  for (const goodie of goodies) {
    // 1) Prüfen, ob dieses Goodie im Cart ist
    const goodieItem = cart.items.find(
      (item) => item.variant_id === goodie.variantId
    );

    // 2) Warenkorbwert OHNE dieses Goodie berechnen
    const subtotalWithoutThisGoodie = cart.items.reduce((sum, item) => {
      if (item.variant_id === goodie.variantId) {
        return sum; // dieses Goodie ignorieren
      }
      return sum + (item.line_price || 0);
    }, 0);

    const threshold = goodie.threshold; // z.B. 8000 in Cent

    // 3) Fall A: Threshold erreicht/überschritten → Goodie soll drin sein
    if (subtotalWithoutThisGoodie >= threshold) {
      if (!goodieItem) {
        await addGoodieToCart(goodie.variantId);

        setTimeout(() => {
          document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        )}, 200);

      
      }
      // weiter mit nächstem Goodie
      continue;
    }

    // 4) Fall B: Threshold unterschritten → Goodie soll raus
    if (subtotalWithoutThisGoodie < threshold && goodieItem) {
      await removeGoodieFromCart(goodieItem.key);
    }
  }
}

/* ----------------------------------------------------------
   7) LISTENER: BEI JEDER WARENKORBÄNDERUNG PRÜFEN
----------------------------------------------------------- */
document.addEventListener('product:added', async () => {
  await checkAndSyncGoodie();
});

document.addEventListener('cart:change', async () => {
  await checkAndSyncGoodie();
});